import { Paper, Typography } from "@mui/material";
import { SingleRouteResponseOfRoadFeatures, SingleRouteResponseOfRoadFeaturesWithBruksklasse } from "../../services/RuteplanAPI";

export interface IRouteSummaryProps {
    route: SingleRouteResponseOfRoadFeaturesWithBruksklasse | SingleRouteResponseOfRoadFeatures;
}

export default function RouteSummary(props: IRouteSummaryProps) {
    const {route} = props;

    function convertMinutesToHoursAndMinutes(minutes: number) {
        const hours = Math.floor(minutes / 60);
        const leftoverMinutes = minutes % 60;
        const roundedMinutes = Math.round(leftoverMinutes);
        const roundedSeconds = Math.round((leftoverMinutes * 60) % 60);
        if (hours === 0) {
            return `${roundedMinutes}min ${roundedSeconds}sec`;
        }
    
        return `${hours}t ${roundedMinutes}min ${roundedSeconds}sec`;
    }

    function convertMetersToKilometers(meters: number) {
        if (meters < 1000) {
            return `${meters}m`;
        }
        return `${(meters / 1000)}km`;
    }
    
    return(
    <>
        { route.statistic && 
        <Paper elevation={0} style={{paddingLeft: "10px"}}>
            <h2>Rutebeskrivelse</h2>
            <Typography>Kjøretid: {convertMinutesToHoursAndMinutes(route.statistic.totalDriveTime)}</Typography>
            <Typography>Avstand: {convertMetersToKilometers(route.statistic.totalLength)}</Typography>
            <Typography>Bomstasjoner: {route.statistic.tollCount}</Typography>
            <Typography>Ferjer: {route.statistic.ferryCount}</Typography>
        </Paper>
        }
    </>
    )
}